module.exports = __webpack_public_path__ + "img/logo_u1992-2.b53b93ec.svg";